import { useState } from 'react';

import { ReactComponent as LocationSelector } from '../../assets/icons/location-selector.svg';
import ModalBox from '../modal-box/ModalBox';

import SelectLatLong from './components/SelectLatLong';

interface SelectLocationProperties {
  inputLabel?: string;
  latitude: string | number | null;
  longitude: string | number | null;
  onChangeValue: (latitude: number, longitude: number) => void;
  valueRequired?: boolean;
  error?: boolean;
  errorMessage?: string;
  readOnly?: boolean;
}

/**
 * Location selector shared component
 */
function SelectLocation({
  inputLabel,
  latitude,
  longitude,
  onChangeValue,
  valueRequired,
  error,
  errorMessage,
  readOnly,
}: SelectLocationProperties) {
  const [locationPopup, setLocationPopup] = useState<'open' | 'close'>('close');
  /**
   * Function to handle lat & long change
   */
  const handleValueChange = (lat: number, long: number) => {
    onChangeValue(lat, long);
    setLocationPopup('close');
  };

  return (
    <div className="select-location-wrap">
      <ModalBox
        open={locationPopup === 'open'}
        title="Title"
        content={
          <SelectLatLong
            latitude={latitude}
            longitude={longitude}
            handleLatLongChange={handleValueChange}
          />
        }
        closeModal={() => setLocationPopup('close')}
        header
        modalBoxAnimation="modalAnimateToLeft"
      />
      {inputLabel && (
        <p className={`input-label ${error && 'error'}`}>
          {inputLabel}
          {valueRequired && <span>*</span>}
        </p>
      )}
      <div className="select-location-lat-long">
        <div className={`select-location-container ${error && 'error'}`}>
          <input
            type="number"
            placeholder="Latitude"
            value={latitude || ''}
            onChange={(event) => handleValueChange(Number(event.target.value), Number(longitude))}
            required={valueRequired}
            readOnly={readOnly}
          />
        </div>
        <div className={`select-location-container ${error && 'error'}`}>
          <input
            type="number"
            placeholder="Longitude"
            value={longitude || ''}
            onChange={(event) => handleValueChange(Number(latitude), Number(event.target.value))}
            required={valueRequired}
            readOnly={readOnly}
          />
          <span role="presentation" onClick={() => setLocationPopup('open')}>
            <LocationSelector />
          </span>
        </div>
      </div>
      {error && <p className="custom-input-error-message">{errorMessage}</p>}
    </div>
  );
}

SelectLocation.defaultProps = {
  inputLabel: '',
  valueRequired: false,
  // readOnly: false,
  error: false,
  errorMessage: '',
  readOnly: false,
};

export default SelectLocation;
